import { MapTo } from '@adobe/aem-react-editable-components';
import PartnerOfferForm, { PartnerOfferFormEditConfig } from './PartnerOfferForm';

export default MapTo('cob-corp-acquisition/components/creditonebank/partner-offer-form')(PartnerOfferForm, PartnerOfferFormEditConfig);